import React from 'react';
import { siteInfo } from '../data/mock';

export const CGUPage = () => {
  return (
    <div className="min-h-screen bg-[#FDF8F3]">
      {/* Hero */}
      <section className="relative py-24 bg-[#2C1810]">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-6xl font-serif font-bold text-white mt-4 mb-6">
            Conditions Générales d'Utilisation
          </h1>
          <div className="w-20 h-1 bg-gradient-to-r from-[#C9A96E] to-[#A67B5B] mx-auto" />
        </div>
      </section>

      {/* Content */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-6 space-y-8">
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h2 className="text-2xl font-serif font-bold text-[#2C1810] mb-4">1. Objet</h2>
            <p className="text-[#5D4037] leading-relaxed">
              Les présentes Conditions Générales d'Utilisation (CGU) ont pour objet de définir les modalités et conditions dans lesquelles 
              {siteInfo.name} met à disposition son site web et les services qui y sont proposés.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h2 className="text-2xl font-serif font-bold text-[#2C1810] mb-4">2. Accès au site</h2>
            <p className="text-[#5D4037] leading-relaxed">
              L'accès au site et son utilisation sont réservés à un usage strictement personnel. 
              Vous vous engagez à ne pas utiliser ce site et les informations ou données qui y figurent à des fins commerciales, 
              politiques, publicitaires et pour toute forme de sollicitation commerciale.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h2 className="text-2xl font-serif font-bold text-[#2C1810] mb-4">3. Réservations</h2>
            <div className="space-y-4 text-[#5D4037] leading-relaxed">
              <p>
                Les réservations effectuées via le site sont soumises à confirmation. 
                {siteInfo.name} se réserve le droit de refuser ou d'annuler toute réservation pour des motifs légitimes.
              </p>
              <p>
                Toute réservation non honorée sans annulation préalable pourra faire l'objet de mesures appropriées.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h2 className="text-2xl font-serif font-bold text-[#2C1810] mb-4">4. Commandes et paiement</h2>
            <div className="space-y-4 text-[#5D4037] leading-relaxed">
              <p>
                Les commandes de produits peuvent être passées sur le site. 
                Le paiement s'effectue <strong>en magasin lors du retrait</strong> de votre commande.
              </p>
              <p>
                Les prix affichés sont en euros TTC. Nous nous réservons le droit de modifier nos prix à tout moment.
              </p>
              <p>
                Les produits restent la propriété de {siteInfo.name} jusqu'au paiement complet du prix.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h2 className="text-2xl font-serif font-bold text-[#2C1810] mb-4">5. Annulation et modification</h2>
            <p className="text-[#5D4037] leading-relaxed">
              Les rendez-vous peuvent être annulés ou modifiés jusqu'à 24h avant la date prévue en nous contactant par téléphone ou email. 
              Toute annulation tardive pourra entraîner la facturation d'un montant forfaitaire.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h2 className="text-2xl font-serif font-bold text-[#2C1810] mb-4">6. Responsabilité</h2>
            <p className="text-[#5D4037] leading-relaxed">
              {siteInfo.name} met tout en œuvre pour offrir aux utilisateurs des informations et/ou des outils disponibles et vérifiés, 
              mais ne saurait être tenu pour responsable des erreurs, d'une absence de disponibilité des informations et/ou de la présence de virus sur son site.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h2 className="text-2xl font-serif font-bold text-[#2C1810] mb-4">7. Contact</h2>
            <div className="space-y-2 text-[#5D4037]">
              <p>Pour toute question relative aux CGU, vous pouvez nous contacter :</p>
              <p><strong>Email :</strong> {siteInfo.email}</p>
              <p><strong>Téléphone :</strong> {siteInfo.phone}</p>
              <p><strong>Adresse :</strong> {siteInfo.address}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
